import LevelTag from '../LevelTag/LevelTag'
import './NewProjectCard.scss'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Tag } from '@raspberrypifoundation/design-system-react'

const NewProjectCard = ({ projectSummary }) => {
  const { t, i18n } = useTranslation()
  const linkUrl = (locale, repositoryName) => {
    return `/${locale}/projects/${repositoryName}`
  }

  return (
    <div className="c-new-project-card">
      <img
        className="c-new-project-card__image"
        src={projectSummary.heroImage}
        alt={projectSummary.title}
      />
      <div className="c-new-project-card__content">
        {projectSummary.difficultyLevel && (
          <LevelTag
            level={projectSummary.difficultyLevel}
            technology={projectSummary.primaryTechnology}
          ></LevelTag>
        )}

        <a
          className="c-new-project-card__heading"
          href={linkUrl(i18n.language, projectSummary.repositoryName)}
        >
          {projectSummary.title}
        </a>
        <p className="c-new-project-card__description">
          {projectSummary.description}
        </p>

        <div className="c-new-project-card__tags">
          {projectSummary.technologyLabels
            .filter((label) => label != projectSummary.primaryTechnology)
            .map((label) => {
              return (
                <Tag
                  key={label}
                  text={t(`general.technology-themes.${label}`)}
                />
              )
            })}
        </div>
      </div>
    </div>
  )
}

NewProjectCard.propTypes = {
  projectSummary: PropTypes.shape({
    id: PropTypes.number.isRequired,
    repositoryName: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    heroImage: PropTypes.string.isRequired,
    difficultyLevel: PropTypes.number,
    hardwareLabels: PropTypes.arrayOf(PropTypes.string),
    technologyLabels: PropTypes.arrayOf(PropTypes.string),
    interestLabels: PropTypes.arrayOf(PropTypes.string),
    primaryTechnology: PropTypes.string.isRequired,
  }).isRequired,
}

export default NewProjectCard
